import { $$ } from 'utils/dom';

const quotes = $$('.landingpage-quote');

if (quotes.length) {
  quotes.forEach(quote => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          } else {
            entry.target.classList.remove('visible');
          }
        });
      },
      {
        rootMargin: '200px 0px 0px 0px',
        threshold: 0.1,
      }
    );
    observer.observe(quote);
  });
}
